// extracted by mini-css-extract-plugin
export default {"container":"styles_container__q2n+q","label":"styles_label__Vhd5w","textarea":"styles_textarea__ZDllx","error":"styles_error__x5GAd","placeholder":"styles_placeholder__RC85X"};